angular.module('app.entity.actions.plugin-lock', [
    'app.entity.actions',
    'app.entity.crud',
    'app.entity.service',
    'app.study-context',
    'event',
    'inetsys.messages',
    'inetsys.modal',
    'ui.router',
]);
